/**
 * vitrine-tabs.js
 * ---------------------------------------------------------------------------
 * Troca de abas da seção Vitrine — clicar numa aba (nome da coleção) mostra
 * o grid de produtos daquela coleção e esconde os outros. Sem dependências.
 * ---------------------------------------------------------------------------
 */
document.addEventListener('click', function (event) {
  const tab = event.target.closest('[data-vitrine-tab]');
  if (!tab) return;

  const wrapper = tab.closest('.vitrine');
  if (!wrapper) return;

  const targetId = tab.getAttribute('data-vitrine-tab');

  wrapper.querySelectorAll('.vitrine-tabs__tab').forEach((btn) => {
    const isActive = btn === tab;
    btn.classList.toggle('active', isActive);
    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  wrapper.querySelectorAll('.vitrine-panel').forEach((panel) => {
    const isActive = panel.id === targetId;
    panel.classList.toggle('active', isActive);
    if (isActive) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });
});
